import * as React from "react";
import {
  Paper,
  CssBaseline,
  Typography,
  Button,
  makeStyles,
  TextField,
} from "@material-ui/core";
import { UserContext } from "../context/UserContext";
import { Link } from "react-router-dom";
import useFormInput from "../hooks/FormHooks";
import { useHistory } from "react-router";
import CheckCircleIcon from "@material-ui/icons/CheckCircleOutline";
import { useSnackbar } from "notistack";

function ForgotPassword() {
  const [resetDone, setResetDone] = React.useState(false);
  const user = React.useContext(UserContext);
  const classes = useStyles();
  const email = useFormInput("");
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  function submit(e: React.FormEvent<HTMLElement>) {
    e.preventDefault();

    if (email.value.length > 0) {
      user.forgotPassword(email.value, (err, resp) => {
        if (err) {
          enqueueSnackbar(err.description, { variant: "error" });
        } else {
          setResetDone(true);
          enqueueSnackbar(resp, { variant: "success" });
        }
      });
    }
  }

  return !resetDone ? (
    <Paper className={classes.paper}>
      <CssBaseline />
      <Typography component="h1" variant="h5" className={classes.title}>
        Reset Password
      </Typography>

      <form className={classes.form}>
        <TextField
          id="email"
          label="Email Address"
          variant="outlined"
          fullWidth
          autoComplete="email"
          autoFocus
          margin="normal"
          required
          {...email}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={submit}
        >
          Reset My Password
        </Button>
      </form>

      <Link to="/login" className={classes.link}>
        Back to Log In Screen
      </Link>
    </Paper>
  ) : (
    <Paper className={classes.paper}>
      <CheckCircleIcon className={classes.icon} />
      <Typography component="h1" variant="h5" className={classes.title}>
        Password Reset
      </Typography>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.button2}
        onClick={() => history.push("/login")}
      >
        Back To Login
      </Button>
    </Paper>
  );
}

export default ForgotPassword;

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%",
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
    marginTop: 30,
  },
  main: {
    width: "auto",
    display: "block",
    marginLeft: 15,
    marginRight: 15,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 34,
    flexGrow: 1,
    borderRadius: 20,
  },
  icon: {
    height: 50,
    width: 50,
    marginBottom: 15,
    color: theme.palette.primary.main,
  },
  button: {
    marginTop: 30,
  },
  button2: {
    marginTop: 16,
  },
  title: {
    marginTop: 35,
    marginBottom: 51,
    fontSize: 30,
    fontWeight: 600,
  },
  error: {
    background: "#B00020",
    color: "white",
    padding: 15,
    width: "100%",
    textAlign: "center",
  },
}));
